import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import toast from 'react-hot-toast';
import { authService } from '../services/authService';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await authService.forgotPassword(email);
      // Anti-enumeration: mostra sempre lo stesso messaggio
      toast.success(res?.detail || 'Se esiste un account con questa email, ti abbiamo inviato un link.');
    } catch (err) {
      // Anche su errore, messaggio generico
      toast.success('Se esiste un account con questa email, ti abbiamo inviato un link.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4 relative"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL || ''}/sfondo-login.png)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="absolute inset-0 bg-white/40"></div>

      <div className="w-full relative z-10">
        <div className="w-full text-center mb-10 px-4">
          <div className="inline-flex items-center justify-center mb-6">
            <img
              src={`${process.env.PUBLIC_URL || ''}/logo.svg`}
              alt="Motore Gare DS - DS Consulting"
              className="h-20 md:h-28 w-auto mx-auto"
            />
          </div>
          <h1 className="font-display text-3xl font-medium mb-3" style={{ color: '#0F1B2D' }}>
            Reimposta password
          </h1>
          <p style={{ color: '#5A6472' }}>
            Inserisci l’email: se esiste un account, riceverai un link.
          </p>
        </div>

        <div className="max-w-md w-full mx-auto">
          <div className="bg-white rounded-2xl shadow-2xl p-8 relative z-10">
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Inserisci la tua email"
                    required
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={isLoading}
                className="w-full py-3 px-4 rounded-lg text-white font-medium transition-all disabled:opacity-60"
                style={{ backgroundColor: '#0F1B2D' }}
              >
                {isLoading ? 'Invio in corso...' : 'Invia link'}
              </button>

              <div className="text-center">
                <Link to="/login" className="text-sm text-blue-600 hover:text-blue-800 underline">
                  Torna al login
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;


